export const FETCH_IRIS_S1_TARGETER = 'FETCH_IRIS_S1_TARGETER';
export const FETCH_IRIS_S1_TARGETER_SUCCESS = 'FETCH_IRIS_S1_TARGETER_SUCCESS';
export const FETCH_IRIS_S1_TARGETER_ERROR = 'FETCH_IRIS_S1_TARGETER_ERROR';
